import React from "react";
import OrgUsers from "src/routes/orguser/OrgUsers";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { useDocumentTitle } from "usehooks-ts";
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import OrgUserView from "src/routes/orguser/OrgUserView";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import { msg as m } from "src/app/msg";
import OrgUserRolesEditor from "src/routes/orguser/OrgUserRolesEditor";
export default function OrgUsersIndex(props) {
  useDocumentTitle(m.title(m.orguser));
  var id = useURLParam('id');
  var items = [{
    id: 'list',
    label: 'Org Users',
    icon: 'list',
    content: /*#__PURE__*/React.createElement(OrgUsers, null),
    queryString: {
      id: undefined
    }
  }, /* {id: 'add', label: 'Add', icon: 'plus', content: <OrgUserEditor/>},*/
  {
    id: 'view',
    label: 'View',
    icon: 'eye',
    show: id !== null,
    content: /*#__PURE__*/React.createElement(OrgUserView, null)
  },
  // {id: 'edit', label: 'Edit', icon: 'edit-2', show: id !== null, content: <OrgUserEditor/>},
  {
    id: 'roles',
    label: 'Roles',
    icon: 'key',
    show: id !== null,
    content: /*#__PURE__*/React.createElement(OrgUserRolesEditor, null)
  }, {
    id: 'delete',
    label: 'Delete',
    icon: 'x',
    show: id !== null,
    __click: function __click(e) {}
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Org Users"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: items
  }));
}